import { Tooltip } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";

export const OverflowTip = ({ children, placement, lineCount = 1 }) => {
  const [isOverflowed, sertIsOverflow] = useState(false);
  const textElementRef = useRef();
  useEffect(() => {
    sertIsOverflow(
      textElementRef.current.scrollWidth > textElementRef.current.scrollWidth
    );
  }, []);
  return (
    <Tooltip title={children} disableHoverListener={isOverflowed} placement={placement}>
      <div
        ref={textElementRef}
        style={lineCount == 1 ? {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        } : {
          textOverflow: "ellipsis",
          WebkitLineClamp: lineCount,
          WebkitBoxOrient: "vertical",
          display: "-webkit-box",
          overflow: "hidden",
        }}
      >
        {children}
      </div>
    </Tooltip >
  );
};
//export default OverflowTip;
